import { Injectable } from "@angular/core";
import { BaseEbrApiClient } from "./ebr-api-client.g";
import { ApiClientConfig } from "./ebr-api-config";

@Injectable({
  providedIn: 'root',
})
export class EbrApiClient extends BaseEbrApiClient {
    constructor(configuration: ApiClientConfig) {
        super(configuration);
    }
}